import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'aa-label-qty',
    templateUrl: './label-qty.component.html',
    styleUrls: [
        './label-qty.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LabelQtyComponent implements OnInit
{
    private labelKlasses: string[] = ['black', 'grey-light', 'white', 'grey-dark'];
    private counterKlasses: string[] = ['primary-normal', 'grey-light'];
    classLabel: string;
    classCounter: string;
    @Input() set colorLabel (colorLabel: string)
    {
        this.classLabel = this.labelKlasses.includes(colorLabel) ? colorLabel : this.labelKlasses[0];
    }
    @Input() set colorCounter (colorCounter: string)
    {
        this.classCounter = this.counterKlasses.includes(colorCounter) ? colorCounter : this.counterKlasses[0];
    }
    @Input() label: string;
    @Input() counter?: number;

    constructor() { }

    ngOnInit ()
    {
    }
}
